import http from '../plugins/axios';

export async function get_all_items(payload) {

    return await http.get('cashier/venueitems', { params: payload });

}

export async function get_apply_coupon_code(input) {
    let data = {
        type_id: input.type_id,
        type: input.type,
        coupon: input.coupon,
        total: input.total
    };
    const response = await http.post('check-coupon', data);
    return response.data;
}
export async function apply_promotion_code(payload) {
    const response = await http.post('promotion/calculate', payload);
    return response.data.data;
}

export async function sale_order_items(payload) {
    const response = await http.post('cashier/order', payload);
    return response.data;
}

export async function update_order(payload) {
    const response = await http.post('cashier/update-order', payload);
    return response.data;
}



export async function update_order_status(input) {
    return await http.post('/cashier/order-report/update-status', input);

}

export async function void_order(payload) {
    let sale_id = payload.sale_id;
    return await http.post('/order/void-sale/' + sale_id, payload);
    ;
}

export async function void_item(payload) {
    let sale_detail_id = payload.sale_detail_id;
    return await http.post(`/order/void-sale-item/${sale_detail_id}`, payload);

}

export async function get_table_status(payload) {
    return await http.get(`/cashier/table/${payload?.table_id}/find-pending-order`, { params: {"type": 'Restaurant', 'type_id': payload?.type_id} });
}

export async function split_sale(payload) {
    const response = await http.post('splitting', payload);
    return response.data;
}

